import { useState, Fragment, useEffect } from "react";
import {
    Container,
    MenuButton,
    DrawerList,
    DrawerListItemButton,
    DrawerListItemContainer,
    ProfileImage,
    StyledDrawer,
    TraslateButton
} from "./styles/DrawerMenuStyles";
import MenuIcon from "@mui/icons-material/Menu";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ImportantInformationModal from "../../../../components/ImportantInformationModal/ImportantInformationModal";
import { isMobile } from "react-device-detect";
import {  ShowGlobalLoading } from "../../../../redux/actions/UiActions";
import { AuthLogout } from "../../../../redux/actions/AuthActions";
import { useTranslation } from 'react-i18next'
import TraslateComponent from'../../../../components/TraslatePage/TraslateComponent'
import LocalStorageService from "../../../../services/LocalStorageService";
import { removeLocalStorageSessionData } from "../../../../auth/AuthFunctions";

function DrawerMenu({ layout }) {
    const [t, i18n] = useTranslation("global");

    const history = useHistory();
    const dispatch = useDispatch();
    const { authenticated } = useSelector((state) => state.authReducer);

    const [drawerState, setDrawerState] = useState(false);
    const [registerInformationModalVisible, setRegisterInformationModalVisible] = useState(false);
    const [userImage, SetUserImage] = useState("");

    const goToRoute = (route) => {
        setDrawerState(false);
        history.push(route);
    };

    const handleregisterInformationModalVisibility = () => {
        setRegisterInformationModalVisible(!registerInformationModalVisible);
    };

    const HandleLogOut = () => {
        dispatch(ShowGlobalLoading('Cerrando sesión'));
        setTimeout(() => { //TO MAKE AN LOGOUT USER EXPERIENCE
            removeLocalStorageSessionData();

            dispatch(AuthLogout());
            window.location.reload();
            //dispatch(HideGlobalLoading());
        }, 1500);

    }
    useEffect(() => {
        SetUserImage(LocalStorageService.getItem('profile_img'))
    }, [])

    return (
        <Container removeRight={layout === "app" ? true : false} layout={layout}>
           {/*  {isMobile &&
                <ImportantInformationModal
                    open={registerInformationModalVisible}
                    buttonTitle='Ir a la store'
                    content='Para tener una mejor experiencia instale la app mitur.'
                    buttonClick={() => goToRoute("/app/register")} //SEND TO DOWNLOAD APP LINK
                    onCloseClick={handleregisterInformationModalVisibility}
                    onBackDropClick={handleregisterInformationModalVisibility}
                />
            } */}

            <MenuButton
                color='inherit'
                startIcon={<MenuIcon style={{ fontSize: "40px" }} />}
                name='drawerState'
                onClick={() => setDrawerState(!drawerState)}
                layout={layout}
            />

            <TraslateButton
                color='inherit'
                startIcon={<TraslateComponent />}
                name='drawerState'

            />
            <StyledDrawer
                anchor={"right"}
                open={drawerState}
                onClose={() => setDrawerState(!drawerState)}
                layout={layout}
            >
                {authenticated && <ProfileImage src={userImage} />}
                <DrawerList>
                    <DrawerListItemContainer layout={layout}>
                        <DrawerListItemButton
                            color='inherit'
                            onClick={() => goToRoute("/app/home")}
                        >
                            {t("start")}
                        </DrawerListItemButton>
                    </DrawerListItemContainer>
                    <DrawerListItemContainer layout={layout}>
                        <DrawerListItemButton
                            color='inherit'
                            onClick={() => goToRoute("/app/allServices")}
                        >
                            {t("service")}
                        </DrawerListItemButton>
                    </DrawerListItemContainer>

                    <DrawerListItemContainer layout={layout}>
                        <DrawerListItemButton
                            color='inherit'
                            onClick={() => goToRoute("/app/contact")}
                        >
                            {t("contact")}
                        </DrawerListItemButton>
                    </DrawerListItemContainer>

                    <DrawerListItemContainer layout={layout}>
                        <DrawerListItemButton
                            color='inherit'
                            onClick={() => goToRoute("/app/guide")}
                        >
                            Guía de Inversión
                        </DrawerListItemButton>
                    </DrawerListItemContainer>
                    {!authenticated ?
                        <Fragment>
                            <DrawerListItemContainer layout={layout}>
                                <DrawerListItemButton
                                    color='inherit'
                                    onClick={() => goToRoute("/public/login")}
                                >
                                    {t("log-in")}
                                </DrawerListItemButton>
                            </DrawerListItemContainer>
                            <DrawerListItemContainer layout={layout}>
                                <DrawerListItemButton
                                    color='inherit'
                                    onClick={(e) => goToRoute("/app/register")}
                                >
                                    {t('Registrar')}
                                </DrawerListItemButton>
                            </DrawerListItemContainer>
                        </Fragment>
                        :
                        <Fragment>
                            <DrawerListItemContainer layout={layout}>
                                <DrawerListItemButton
                                    color='inherit'
                                    onClick={() => goToRoute("/app/myDesk")}
                                >
                                    {t("desk")}
                                </DrawerListItemButton>
                            </DrawerListItemContainer>

                            <DrawerListItemContainer layout={layout}>
                                <DrawerListItemButton
                                    color='inherit'
                                    onClick={() => goToRoute("/app/myConfiguration")}
                                >
                                    {t('My_settings')}
                                </DrawerListItemButton>
                            </DrawerListItemContainer>
                        </Fragment>
                    }
                </DrawerList>
                {
                    authenticated &&
                    <div>
                        <DrawerListItemContainer layout={layout}>
                            <DrawerListItemButton
                                color='inherit'
                                onClick={HandleLogOut}
                            >
                                {t('Sign_off')}
                            </DrawerListItemButton>
                        </DrawerListItemContainer>
                    </div>
                }
            </StyledDrawer>
        </Container>
    );
}

export default DrawerMenu;
